import { DateTime } from "luxon";
import type { BookingScheduleInterface } from "../../Booking-Form/typings/booking.types";
import {
  classifyDashboard2BookingBucket,
  type Dashboard2BookingBucket
} from "../../Dashboard2/utils/dashboard2-primary-booking.utils";
import { selectPrimaryBookingForUserOnDay } from "../../Dashboard2/utils/dashboard2-schedule-filter.utils";
import type { BookableBookingObjectDto } from "../typings/resource-calendar.types";

const PREFILL_BOOKING_BUCKETS = new Set<Dashboard2BookingBucket>(["workplace", "conference"]);

function locationInventoryIdFromSchedule(schedule: BookingScheduleInterface): number | null {
  if (schedule.locationInventoryId != null) {
    return schedule.locationInventoryId;
  }

  const inventory = schedule.bookingInventory as { locationInventoryId?: number | null };
  return inventory.locationInventoryId ?? null;
}

/**
 * Prefill resource-booking location from today's primary workplace or room booking.
 * Workplace wins over conference when both exist (same priority as Dashboard2).
 */
export function resolveLocationInventoryIdForResourcePrefill(
  schedules: BookingScheduleInterface[],
  userId: string
): number | null {
  const primaryBooking = selectPrimaryBookingForUserOnDay(schedules, userId, DateTime.now());

  if (!primaryBooking) {
    return null;
  }

  const bucket = classifyDashboard2BookingBucket(primaryBooking);
  if (!PREFILL_BOOKING_BUCKETS.has(bucket)) {
    return null;
  }

  return locationInventoryIdFromSchedule(primaryBooking);
}

export function filterBookableObjectsByLocationIds(
  objects: BookableBookingObjectDto[],
  selectedLocationIds: number[]
): BookableBookingObjectDto[] {
  if (selectedLocationIds.length === 0) {
    return objects;
  }

  const selectedIds = new Set(selectedLocationIds);
  return objects.filter(
    object => object.locationInventoryId != null && selectedIds.has(object.locationInventoryId)
  );
}
